/**
 * Certain calls run unreliably in FiniteScrolled articles, so initialize them here
 */
export const runFiniteScrollInit = () => {
  setTimeout(() => {
    if (window.__mm_content_enrichment__?.renderEmbeds) {
      window.__mm_content_enrichment__.renderEmbeds();
    }
  }, 500);
};
